module.exports = __webpack_public_path__ + "static/12-5183e2b0eccf50121c9d1a89b6673e29.jpg";